const defaultState = {
    loader: false,
    data: {}
};

import axios from 'axios';

export default {
    namespaced: true,
    name: 'agentPointsList',
    state() {
        return defaultState;
    },
    actions: {
        updateAgentPoints({ dispatch }, widget_info) {
            dispatch('getAgentPoints', widget_info);
        },
        dynamicUpdateAgentPoints({ state, dispatch }) {
            dispatch('getAgentPoints', state.board_id);
        },
        getAgentPoints({ state, commit }, board_id) {
            if (!board_id) { return; }
            if (state.loader) { return; }
            commit('setLoader', true);
            let url = `${process.env.VUE_APP_URL}/sync/sales_stats/points?board_id=${board_id}`;
            axios({ url, method: 'GET' }).then((res) => {
                commit('update', { data: res.data.statistic, board_id });
                setTimeout(() => {
                    commit('setLoader', false);
                }, 100);
            }, (err) => {
                console.warn(err);
                setTimeout(() => {
                    commit('setLoader', false);
                }, 100);
            });
        }
    },
    mutations: {
        setLoader(state, value) {
            state.loader = value;
        },
        update(state, { board_id, data }) {
            state.data = data;
            state.board_id = board_id;
        },
    }
};
